// extracted by css-extract-rspack-plugin
export default {"editorBodyWrapper":"kmYsM"};